import React from 'react';
import styles from '../Blog.module.css';
import arrowIcon from '../../../../assets/images/mojo-login-img/arrow-icon.svg';

export default function Post({ item }) {
  // Helper function to strip HTML tags
  const stripTags = (html) => {
    if (!html) return ''; // Return an empty string if `html` is undefined or null
    return html.replace(/<[^>]*>?/gm, ''); // Use replace safely
  };

  // Helper function to trim text to a specified length
  const trimToLength = (text, length) => {
    return text.length > length ? `${text.substring(0, length)}...` : text;
  };

  return (
    <div className={styles.BlogItem} key={item.id}>
      <div className={styles.BlogTitle}>{trimToLength(item.title, 60)}</div>
      <div className={styles.BlogContent}>
        {trimToLength(stripTags(item.content_html), 160)}
      </div>
      <a
        className={styles.BlogItemLink}
        href={item.url}
        target="_blank"
        rel="noopener noreferrer"
      >
        See more
        <img src={arrowIcon} alt="" style={{ marginLeft: '6px' }} />
      </a>
    </div>
  );
}
